var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stu_record"},[_c('TopNavBar',{attrs:{"tabArr":_vm.tabArr},on:{"onItemClick":_vm.onItemClick}}),_c('keep-alive',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }